import styled from "styled-components"

export const BasicTextModuleStyles = styled.section`
  .basic__inner {
    max-width: 880px;

    .eyebrow {
      margin-bottom: 1.5rem;
    }

    h2 {
      font-size: var(--text-title);
      line-height: 1.04;
      margin-bottom: 1.5rem;
    }

    .lead {
      font-size: var(--text-lead);
      line-height: 1.5;
      color: var(--color-ash);
      max-width: 720px;
    }
  }
`
